import { Component, OnInit, Inject, Optional } from '@angular/core';
import {Requests} from 'src/app/_model/Requests';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbsenceService } from 'src/app/_services/absence.service';
import { ToastrService } from 'ngx-toastr';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import {RequestService} from "../../_services/request.service";
import {WfCompleteRequest} from "../../_model/request/WfCompleteRequest";

@Component({
    selector: 'app-requestsCompleteSelected',
    templateUrl: './requestsCompleteSelected.html',
    styleUrls: ['./requestsCompleteSelected.css'],
    standalone: true,
        imports: [
            MatDialogModule
        ]
})
export class RequestsCompleteSelectedComponent implements OnInit {
    request:WfCompleteRequest=new WfCompleteRequest();
    currentUser: User;
    constructor(public dialogRef: MatDialogRef<RequestsCompleteSelectedComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Requests[],
                private requestService: RequestService,
                private authService: AuthenticationService,
                private toastr: ToastrService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
    }
    completeSelected(){

        this.data.forEach(element => {
            this.request.id = element.id;
            this.requestService.completeRequests(this.request).subscribe(result => {
                this.toastr.success('Tamamlama işlemi başarılı', '');
                this.dialogRef.close();
            }, error => {
                this.toastr.error(error.error.msg, 'Hata');
                this.dialogRef.close();
            });
        });

    }
}
